import React, { useState } from 'react';
import './VPSLinux.css';

const VPSLinux = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const plans = [
    {
      tier: 'شخصی',
      price: '۲۵۰',
      unit: 'هزار تومان / ماه',
      cpu: '2 Core',
      ram: '۴ GB',
      storage: '۵۰ GB NVMe',
      bandwidth: '۱ TB',
      features: ['Root Access', 'سی‌پنل / دایرکت‌ادمین', 'پشتیبانی ۲۴/۷', 'آپتایم ۹۹.۹٪'],
      popular: false,
    },
    {
      tier: 'کسب‌وکار',
      price: '۴۵۰',
      unit: 'هزار تومان / ماه',
      cpu: '4 Core',
      ram: '۸ GB',
      storage: '۱۰۰ GB NVMe',
      bandwidth: '۲ TB',
      features: ['Root Access', 'سی‌پنل / دایرکت‌ادمین', 'پشتیبانی ۲۴/۷', 'آپتایم ۹۹.۹٪', 'بکاپ خودکار'],
      popular: true,
    },
    {
      tier: 'سازمانی',
      price: '۷۵۰',
      unit: 'هزار تومان / ماه',
      cpu: '8 Core',
      ram: '۱۶ GB',
      storage: '۲۰۰ GB NVMe',
      bandwidth: '۴ TB',
      features: ['Root Access', 'سی‌پنل / دایرکت‌ادمین', 'پشتیبانی ۲۴/۷', 'آپتایم ۹۹.۹٪', 'بکاپ خودکار', 'IP اختصاصی'],
      popular: false,
    },
  ];

  const features = [
    {
      icon: '🐧',
      title: 'سیستم‌عامل لینوکس با پایداری بالا',
      desc: 'VPS لینوکس با انتخاب سیستم‌عامل مورد نظر شما (Ubuntu، CentOS، Debian، AlmaLinux و ...) ارائه می‌شود. لینوکس به دلیل پایداری بالا، امنیت عالی و هزینه کمتر، محبوب‌ترین انتخاب برای سرورهای مجازی است.',
    },
    {
      icon: '💻',
      title: 'پشتیبانی از زبان‌های برنامه‌نویسی متنوع',
      desc: 'VPS لینوکس از زبان‌های برنامه‌نویسی PHP، Python، Node.js، Ruby، Perl و بسیاری دیگر پشتیبانی می‌کند. شما می‌توانید هر نوع اپلیکیشن وب را روی VPS لینوکس اجرا کنید.',
    },
    {
      icon: '🛡️',
      title: 'امنیت پیشرفته و به‌روزرسانی خودکار',
      desc: 'سرورهای VPS لینوکس با به‌روزرسانی خودکار امنیتی و سیستم‌های حفاظتی پیشرفته، از داده‌های شما در برابر تهدیدات سایبری محافظت می‌کنند.',
    },
    {
      icon: '⚡',
      title: 'عملکرد فوق‌العاده با NVMe',
      desc: 'استفاده از دیسک‌های NVMe با سرعت خواندن و نوشتن بالا برای بارگذاری سریع‌تر وب‌سایت شما و بهبود تجربه کاربری.',
    },
  ];

  const faqs = [
    {
      q: 'VPS لینوکس برای چه پروژه‌هایی مناسب است؟',
      a: 'VPS لینوکس برای طیف گسترده‌ای از پروژه‌ها مناسب است از جمله: وب‌سایت‌های با ترافیک بالا، فروشگاه‌های آنلاین، اپلیکیشن‌های وب، API‌ها، بازی‌های آنلاین، سرورهای بازی، هاستینگ وب، سرورهای ایمیل، VPN و هر نوع پروژه‌ای که به کنترل کامل روی سرور نیاز دارد. همچنین برای توسعه‌دهندگان و برنامه‌نویسان که نیاز به محیط تست و توسعه دارند، گزینه‌ای ایده‌آل است.',
    },
    {
      q: 'آیا می‌توانم روی VPS لینوکس کنترل پنل نصب کنم؟',
      a: 'بله، شما می‌توانید روی VPS لینوکس خود انواع کنترل پنل‌های محبوب مانند cPanel، DirectAdmin، Plesk، Webmin و Virtualmin را نصب کنید. همچنین ما در افرسل امکان نصب و راه‌اندازی کنترل پنل را به صورت رایگان برای شما انجام می‌دهیم. شما فقط کافی است درخواست خود را ثبت کنید و تیم ما بقیه کارها را انجام می‌دهد.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>VPS لینوکس | خرید سرور مجازی لینوکس با بهترین قیمت | افرسل</h1>
        <p>خرید VPS لینوکس با سرورهای NVMe، روت کامل و پشتیبانی ۲۴ ساعته. سرور مجازی لینوکس مناسب برای توسعه‌دهندگان، برنامه‌نویسان و وب‌سایت‌های پرترافیک.</p>
        <meta name="description" content="خرید VPS لینوکس با بهترین قیمت از افرسل. سرور مجازی لینوکس با NVMe، Root Access، پشتیبانی ۲۴/۷ و آپتایم ۹۹.۹٪." />
      </div>

      <section className="vps-linux-hero">
        <div className="vps-linux-hero-bg"></div>
        <div className="wrap">
          <div className="vps-linux-hero-content">
            <div className="vps-linux-badge">
              <span className="pulse-dot"></span>
              🐧 VPS لینوکس
            </div>
            <h1 className="vps-linux-hero-title">
              سرور مجازی <em>لینوکس</em>
            </h1>
            <p className="vps-linux-hero-desc">
              VPS لینوکس با سرورهای NVMe، دسترسی روت کامل و پشتیبانی ۲۴ ساعته.
              مناسب برای توسعه‌دهندگان، برنامه‌نویسان و وب‌سایت‌های پرترافیک با نیاز به کنترل کامل روی سرور.
            </p>
            <div className="vps-linux-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۳</span>
                <span className="stat-label">پلن مختلف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">NVMe</span>
                <span className="stat-label">دیسک فوق‌سریع</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">Root</span>
                <span className="stat-label">دسترسی کامل</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="vps-linux-plans">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پلن‌های VPS لینوکس</span>
            <h2 className="sec-h">پلن <em>مناسب</em> پروژه خود را انتخاب کنید</h2>
            <p className="sec-p">پلن‌های متنوع VPS لینوکس با قیمت‌های رقابتی و منابع کافی برای هر نوع پروژه.</p>
          </div>
          <div className="vps-linux-plans-grid">
            {plans.map((plan, i) => (
              <div key={i} className={`vps-linux-plan ${plan.popular ? 'popular' : ''}`}>
                {plan.popular && <span className="vps-linux-popular-badge">پرفروش‌ترین</span>}
                <div className="vps-linux-plan-tier">{plan.tier}</div>
                <div className="vps-linux-plan-price">
                  <span className="vps-linux-plan-num">{plan.price}</span>
                  <span className="vps-linux-plan-unit">{plan.unit}</span>
                </div>
                <div className="vps-linux-plan-specs">
                  <div><span>🖥️</span> {plan.cpu}</div>
                  <div><span>💾</span> {plan.ram}</div>
                  <div><span>📀</span> {plan.storage}</div>
                  <div><span>📶</span> {plan.bandwidth}</div>
                </div>
                <ul className="vps-linux-plan-features">
                  {plan.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <button className="vps-linux-order-btn" onClick={() => scrollTo('contact')}>سفارش دهید</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-linux-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای VPS لینوکس</span>
            <h2 className="sec-h">چرا <em>VPS لینوکس</em> با افرسل؟</h2>
            <p className="sec-p">VPS لینوکس با بهترین امکانات و خدمات برای توسعه‌دهندگان و کسب‌وکارها.</p>
          </div>
          <div className="vps-linux-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="vps-linux-feature-card">
                <span className="vps-linux-feature-icon">{feature.icon}</span>
                <h3 className="vps-linux-feature-title">{feature.title}</h3>
                <p className="vps-linux-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-linux-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
          </div>
          <div className="vps-linux-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="vps-linux-faq-item">
                <div className="vps-linux-faq-q">{faq.q}</div>
                <div className="vps-linux-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-linux-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              VPS <em>لینوکس</em> را همین حالا خریداری کنید
            </h2>
            <p className="cta-desc">
              با خرید VPS لینوکس، از سرعت بالا، پایداری عالی و پشتیبانی ۲۴ ساعته بهره‌مند شوید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>خرید VPS</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VPSLinux;
